import React, { useState, useContext, useEffect } from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import { FaClock } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import BookIcon1 from "../images/book1.svg";
import BookIcon2 from "../images/book2.svg";
import BookIcon3 from "../images/book3.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Functions from "../../utility/services/Functions";
import ImageConfig from "../../utility/configs/imageConfig";
import ConstConfig from "../../utility/configs/constConfig";
import ApiService from "../../utility/services/ApiService";
import { toast } from "react-toastify";
import { AuthContext } from "../../utility/services/AuthContext";
import SuccessIcon from "../images/success.svg";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import moment from "moment";
import UserAvatar from "../common/UserAvatar";
import { trackScreenView, trackButtonClick, trackEvent } from "../../utility/services/analyticsService";
const BookAnAppointment = () => {
  // LOGICAL VARIABLES
  const location = useLocation();

  const { setLoading, user } = useContext(AuthContext);
  const {
    scheduledTimeForTherapist,
    consoleService,
    formet_date,
    formet_time,
    get_day,
    combine_time_to_date,
    simpleArrayString,
  } = Functions();
  const {
    get_booking_timing_for_patient,
    get_therapist_booked_dates_for_patient,
    get_card_list,
    add_booking,
  } = ApiService();

  const navigate = useNavigate();

  const therapistDetails = location?.state?.therapistDetails;
  const default_selected_price = location?.state?.price_item;
  const isTherapistDetails = therapistDetails != undefined;

  const date = new Date();
  const maxDate = new Date().setDate(new Date().getDate() + 15);

  const foundtimeSlots = therapistDetails?.pricing.find(
    (item) => item?.checked == true
  );

  const [modalShow, setModalShow] = React.useState(false);

  // DATA VARIABLES
  const [initialTimeSlot, setInitialTimeSlot] = useState(
    default_selected_price ? default_selected_price : foundtimeSlots
  );
  const [timeSlots, setTimeSlots] = useState([]);
  const [dateValue, onChange] = useState(new Date());
  const [timeValue, setTimeValue] = useState("");
  const [bookedDates, setBookedDates] = useState([]);
  const is_any_slot_available = timeSlots.some(
    (item) => new Date(item.slot) > new Date()
  );

  // USE EFFECT

  useEffect(() => {
    trackEvent("select_session_duration_cta", {
      event_type: "item_click",
      screen_name: "Book Appointment",
      user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "",
      user_role: user.details?.role,
      therapist_name: therapistDetails?.name,
      session_type: `${initialTimeSlot?.time_in_min}min`,
      session_price: initialTimeSlot?.price,
    });
    fetch_booked_dates();
    set_available_time_slots(dateValue, initialTimeSlot?.time_in_min);
  }, []);

  // FUNCTIONS

  const fetch_booked_dates = async () => {
    try {
      const res = await get_therapist_booked_dates_for_patient(
        therapistDetails._id,
        initialTimeSlot.time_in_min
      );
      const booked_dates = res.data.booked_dates.map((item) =>
        formet_date(item)
      );
      // setBookedDates([...booked_dates]);
    } catch (err) {
      consoleService("erro in fetch_booked_dates fun = ", err);
    }
  };

  const disabled_dates = ({ _, date }) => {
    const userActiveDays = [];

    therapistDetails.availability.forEach((item) => {
      if (item.checked) {
        userActiveDays.push(item.day);
      }
    });

    const day = get_day(date);
    const isFound = userActiveDays.some((item) => item == day);

    if (!isFound) {
      // return true;
      return false;
    } else {
      const isFoundBooked = bookedDates.some(
        (item) => item == formet_date(day)
      );
      // if (isFoundBooked) {
      //   return true;
      // } else {
      //   return false;
      // }
      if (isFoundBooked) {
        return false;
      } else {
        return false;
      }
    }
  };

  async function set_available_time_slots(date, slot) {
    setLoading(true);

    try {
      const filter_date = moment(date).format("YYYY-MM-DD");
      const res = await get_booking_timing_for_patient(
        therapistDetails._id,
        filter_date,
        slot
      );

      if (res.status === 1) {
        const data = res.data;

        const allslots = data.all_slots;
        const emptySlots =
          data.fetchedRes.booked_time_stamps.length > 0
            ? data.fetchedRes.empty_time_stamps
            : allslots;

        const slots = [];

        allslots.forEach((item, index) => {
          const isEmpty = emptySlots.some(
            (emptySlot) => formet_time(emptySlot) == formet_time(item)
          );

          if (isEmpty) {
            const isToday =
              formet_date(new Date()) == formet_date(new Date(date));

            if (isToday) {
              const todayTime = Date.now();
              const combineTime = combine_time_to_date(new Date(), item);
              const stampTime = new Date(combineTime).getTime();
              const isPast = todayTime >= stampTime;
              consoleService("condtitions =", { combineTime, stampTime });
              if (todayTime < stampTime) {
                slots.push({ slot: item, booked: false });
              } else {
                slots.push({ slot: item, booked: true });
              }
            } else {
              slots.push({ slot: item, booked: false });
            }
          } else {
            slots.push({ slot: item, booked: true });
          }
        });

        setTimeSlots([...slots]);
        onChange(date);
        setTimeValue("");
        setLoading(false);
        return;
      } else {
        setLoading(false);
        consoleService("error in set_available_time_slots fun = ", res);
        return;
      }
    } catch (err) {
      consoleService("error in set_available_time_slots fun = ", err);
      setLoading(false);

      return;
    }
  }

  const setSlotValueFun = async (item) => {
    trackEvent("select_session_duration_cta", {
      event_type: "item_click",
      screen_name: "Book Appointment",
      user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "",
      user_role: user.details?.role,
      therapist_name: therapistDetails?.name,
      session_type: `${item.time_in_min}min`,
      session_price: item.price,
    });
    trackScreenView("pricing_screen", { therapist_name: therapistDetails?.name });
    await set_available_time_slots(dateValue, item.time_in_min);
    setInitialTimeSlot(item);
  };

  const proceed_fun = async () => {
    trackButtonClick("continue_to_pricing_cta", {
      button_text: "Proceed",
      therapist_name: therapistDetails?.name,
      session_type: `${initialTimeSlot?.time_in_min}min`,
    });
    try {
      if (timeValue) {
        trackButtonClick("proceed_to_checkout_cta", {
          button_text: "Proceed",
          therapist_name: therapistDetails?.name,
          session_type: `${initialTimeSlot?.time_in_min}min`,
          screen_name: "session_selection_screen",
        });
        setLoading(true);
        const finalTimeValue = combine_time_to_date(dateValue, timeValue);

        navigate("/enterpaymentdetails", {
          replace: true,
          state: {
            therapistDetails: therapistDetails,
            priceData: initialTimeSlot,
            date: finalTimeValue.toUTCString(),
            time: finalTimeValue.toUTCString(),
            navigateFromBooking: true,
          },
        });
      } else {
        toast("Please select a appointment time first", {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      consoleService("err in proceed fun = ", err);
    }
  };

  // NESTED COMPONENTS

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" />
          <h4>Confirmed</h4>
          <p>
            Your appointment has been scheduled and will update the status as
            soon as it's accepted.
          </p>
          <h4 style={{ fontSize: "1em" }}>{props.therapistDetails.name}</h4>
          <p>
            {formet_date(props.time)} | {formet_time(props.time)} <br />
            {props.therapistDetails.speciality_name.map((item, index) => {
              return simpleArrayString(
                item,
                index,
                props.therapistDetails.speciality_name
              );
            })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            // className="btn btn-primary "
            onClick={() => {
              setModalShow(false);
              setTimeValue("");
              navigate(-1, { replace: true });
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
  //
  return (
    <>
      <BannerSection
        banner={Banner}
        name={"Home"}
        title={"Therapist Details"}
      />
      {isTherapistDetails && (
        <>
          <section className="py-5 detailsBox book_appointment_detail_box">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="userDetails userDetails_box">
                    <UserAvatar
                      profileImage={therapistDetails.profile_img}
                      firstName={therapistDetails.first_name || therapistDetails.name}
                      lastName={therapistDetails.last_name}
                      size="xl"
                      className="img-fluid thimg"
                      alt={`${therapistDetails.name} profile`}
                    />
                    <div className="rightflex rightflex_box">
                      <div className="d-flex align-items-center mb-3">
                        <img src={BookIcon1} alt="" className="img-fluid" />
                        <h2 className="ms-2" style={{ color: "black" }}>
                          {therapistDetails.name}
                        </h2>
                      </div>
                      <div className="d-flex align-items-center mb-3">
                        <img src={BookIcon2} alt="" className="img-fluid" />
                        <div className="speciality_container">
                          {therapistDetails.speciality_name
                            .map((item) => item.trim())
                            .join(", ")}
                          .
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <img src={BookIcon3} alt="" className="img-fluid" />
                        <h4 className="mb-0 ms-2">
                          {" "}
                          {scheduledTimeForTherapist(
                            therapistDetails.pricing,
                            initialTimeSlot.id
                          )}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="pb-5 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Package</h2>
                  <ul>
                    {therapistDetails.pricing.map((item, index) => {
                      if (item.checked) {
                        return (
                          <li
                            key={index}
                            onClick={() => {
                              setSlotValueFun(item);
                            }}
                            className={
                              item.id == initialTimeSlot.id && "active"
                            }
                          >
                            <div className="package_box">
                              <h3>
                                <FaClock />{" "}
                                {scheduledTimeForTherapist(
                                  therapistDetails.pricing,
                                  item.id
                                )}
                              </h3>
                              <h3 className="mb-0">$ {item.price}</h3>
                            </div>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="pb-5 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-5">
                  <h2>Select Date</h2>
                  <Calendar
                    onChange={(date) => {
                      set_available_time_slots(
                        date,
                        initialTimeSlot.time_in_min
                      );
                    }}
                    value={dateValue}
                    minDate={date}
                    // maxDate={new Date(maxDate)}
                    tileDisabled={disabled_dates}
                    tileClassName="calendar_tiles"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="packagebox packagebox11 slotBox">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>
                    {/* {timeSlots.length > 0
                      ? "Choose Time Slot"
                      : "Please Select Any Available Date To See Time Slots"} */}
                    {timeSlots.length > 0 && "Choose Time Slot"}
                  </h2>
                  <ul>
                    {timeSlots.length > 0 && is_any_slot_available ? (
                      timeSlots.map((item, index) => {
                        consoleService("slot =", {
                          slot_time: new Date(item.slot),
                          cuttent_time: new Date(),
                          conditions: new Date(item.slot) > new Date(),
                        });
                        return (
                          <>
                            {new Date(item.slot) > new Date() && (
                              <li key={index}>
                                <Link
                                  onClick={(e) => {
                                    e.preventDefault();

                                    !item.booked && setTimeValue(item.slot);
                                  }}
                                  className={`timebox ${
                                    item.booked
                                      ? "grey"
                                      : timeValue == item.slot
                                      ? "selected"
                                      : "active"
                                  }`}
                                >
                                  {formet_time(new Date(item.slot))}
                                </Link>
                              </li>
                            )}
                          </>
                        );
                      })
                    ) : (
                      <span>Therapist is not available for this date</span>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <div className="text-center py-5">
            {timeSlots.length > 0 && (
              <Button
                className="btn btn-primary bookbtn"
                onClick={() => {
                  proceed_fun();
                }}
              >
                Proceed
              </Button>
            )}
          </div>
          <MyVerticallyCenteredModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            date={dateValue}
            time={timeValue}
            therapistDetails={therapistDetails}
          />
        </>
      )}
    </>
  );
};

export default BookAnAppointment;
